import React from "react";

const Footer = () => (
  <footer className="px-6">
    <span className="font-bold text-gray-700 uppercase">Sites</span>

    <div className="flex flex-col">
      <span>
        <a
          href="https://aguilargonzalo.com/"
          className="text-blue-700  text-md hover:text-blue-500"
        >
          My web
        </a>
      </span>

      <span>
        <a
          href="https://www.linkedin.com/in/gonzalo-simon-aguilar/"
          className="text-blue-700  text-md hover:text-blue-500"
        >
          LinkedIn
        </a>
      </span>
    </div>
  </footer>
);

export default Footer;
